
const Censo = () => {
  return (
    <main
      style={{
        width: '100%',
        height: 'calc(100vh - 80px)',
        minHeight: '800px'
      }}
    >
      <iframe
        src="https://chriscastro-censo2024.share.connect.posit.cloud/"
        title="Censo 2024 - Demográfica"
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        allowFullScreen
      />
    </main>
  )
}

export default Censo
